import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Input, Tooltip, Button, Modal } from 'components';
import { CleanIcon, DeleteIcon, EditIcon, AddIcon, SurgerieIcon, ExamIcon } from 'assets/icons';
import { ServiceService } from 'services';
import { WhiteImage } from 'assets/img';
import { Constants, Globals, checkPermission, Permissions } from 'utils';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	speciality: '',
	area: ''
}

class Services extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'',
			'Nombre',
			'Unidad',
			'Especialidad',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		type_id: Constants.SERVICE_TYPES.EXAM
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Servicios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ServiceService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			type_id: this.state.type_id
		});
		this.setState({
			data: res.services.rows,
			last_page: res.services.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});	
	}

	add = () => {
		this.setState({
			visible: true
		});	
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el servicio?',async () => {
			await ServiceService.admin.delete({
				service_id: item.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="admin-services">
				<Modal
		          className="modal-create-service"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	type_id={ this.state.type_id }
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<div className="row container-tabs">
		      		<div className="col-md-6">
		      			<div className={ `tab-item ${ this.state.type_id == Constants.SERVICE_TYPES.EXAM ? 'active' : '' }` } onClick={ () => {
		      				this.setState({
		      					type_id: Constants.SERVICE_TYPES.EXAM,
		      					page: 1
		      				},() => this.load());
		      			} }>
		      				<img src={ ExamIcon } />
		      				<p>Exámenes</p>
		      			</div>
		      		</div>
		      		<div className="col-md-6">
		      			<div className={ `tab-item ${ this.state.type_id == Constants.SERVICE_TYPES.SURGERIES ? 'active' : '' }` } onClick={ () => {
		      				this.setState({
		      					type_id: Constants.SERVICE_TYPES.SURGERIES,
		      					page: 1
		      				},() => this.load());
		      			} }>
		      				<img src={ SurgerieIcon } />
		      				<p>Cirugías</p>
		      			</div>
		      		</div>
		      	</div>

				<div className="row row-filter">
					<div className="col-md-3">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-3">
						<Input
							value={ this.state.form.area }
							name="area"
							label="Buscar por unidad"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-3">
						<Input
							value={ this.state.form.speciality }
							name="speciality"
							label="Buscar por especialidad"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Servicios Registrados" data={ this.state.data.length } header={ this.state.header } rightAlign={[ 4 ]} titleRight={
					<React.Fragment>
						{
							checkPermission(Constants.MODULES.SERVICES,'write',this.props.user) && (
								<Button className="btn-add" onClick={ () => this.add() }>
									<img src={ AddIcon } />
									Nuevo
								</Button>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									<img className="service-image" src={ i.photo ? (Constants.BASE_STORAGE + i.photo) : WhiteImage } />
								</td>
								<td className="vertical-center">{ i.name }</td>
								<td className="vertical-center">{ i.area?.name || '-' }</td>
								<td className="vertical-center">{ i.speciality?.name || '-' }</td>
								<td className="vertical-center text-right">
									{
										checkPermission(Constants.MODULES.SERVICES,'write',this.props.user) && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SERVICES,'delete',this.props.user) && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ DeleteIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Services);